import LoginMedia from '@assets/login.svg?react';
import { Box, Theme, Typography } from '@mui/material';
const LoginSidebar = () => {
 return (
  <Box
   sx={{
    width: '50%',
    color: 'white',
    p: '75px',
    background: (theme: Theme) => theme.palette.kemek.blue,
    display: { xs: 'none', md: 'flex' },
    flexDirection: 'column',
    justifyContent: 'center',
    //    alignItems: 'center',
   }}
  >
   <Typography sx={{ mb: '160px', ml: '45px', fontSize: 36, width: 360 }}>
    Efficient weighing, easy access
   </Typography>
   <LoginMedia />
  </Box>
 );
};
export default LoginSidebar;
